import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button } from "antd";

export const columns = (naviagteTo, showModal) => [
    {
      title: "Gouvernorat",
      dataIndex: "government",
      key: "government",
      render: (data) => <>{data?.name}</>,
    },
    {
      title: "Région",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Action",
      key: "action",
      render: (record) => (
        <>
          <Button
            type="link"
            className="darkbtn"
            onClick={() => naviagteTo(`edit/région/${record.id}`)}
          >
            <EditOutlined /> Modifier
          </Button>
          <Button type="link" danger onClick={() => showModal(record.id)}>
            <DeleteOutlined /> Supprimer
          </Button>
        </>
      ),
    },
  ];
